import { z } from 'zod';
import { countryCodeSchema, phoneNumberSchema, validatePhone } from '../common/phone-number.js';
export var MessagingAppEnum;
(function (MessagingAppEnum) {
    MessagingAppEnum["WECHAT"] = "wechat";
    MessagingAppEnum["WHATSAPP"] = "whatsapp";
    MessagingAppEnum["TELEGRAM"] = "telegram";
    MessagingAppEnum["SKYPE"] = "skype";
})(MessagingAppEnum || (MessagingAppEnum = {}));
export const messagingAppItemSchema = z.object({
    app: z.enum(MessagingAppEnum),
    handle: z.string(),
});
export const contactSchema = z
    .object({
    phone_mobile: phoneNumberSchema.meta({ ...phoneNumberSchema.meta(), label: 'Mobile Phone' }),
    phone_mobile_country_code: countryCodeSchema,
    phone_work: phoneNumberSchema
        .meta({ ...phoneNumberSchema.meta(), label: 'Work Phone' })
        .optional(),
    phone_work_country_code: countryCodeSchema,
    phone_other: phoneNumberSchema
        .meta({ ...phoneNumberSchema.meta(), label: 'Other Phone' })
        .optional(),
    phone_other_country_code: countryCodeSchema,
    messaging_apps: z
        .array(messagingAppItemSchema)
        .meta({ field: 'messaging_apps', label: 'Messaging Apps' })
        .default([]),
})
    .superRefine((data, ctx) => {
    validatePhone(ctx, 'phone_mobile', data.phone_mobile, data.phone_mobile_country_code);
    validatePhone(ctx, 'phone_work', data.phone_work, data.phone_work_country_code);
    validatePhone(ctx, 'phone_other', data.phone_other, data.phone_other_country_code);
});
